import { stringifyUrl } from '../baseQuery';
export var getCampaignCompletesStatsEndpoint = function(builder) {
    return builder.query({
        query: function(param) {
            var id = param.id, query = param.query;
            return stringifyUrl("/campaigns/".concat(id, "/completes_stats"), query);
        },
        keepUnusedDataFor: 15
    });
};
